export default {
    namespaced: true,
    state: {
        locale: 'fr',
        langs: ['fr', 'en'],
        app_url: process.env.MIX_APP_URL
    },
    getters: {
        locale(state) {
            return state.locale;
        },
        langs(state) {
            return state.langs;
        },
        app_url(state) {
            return state.app_url
        }
    },
    actions: {
        setLocale({ commit }, locale) {
            commit('SET_LOCALE', locale)
        }
    },
    mutations: {
        SET_LOCALE( state, locale) {
            state.locale = locale;
        },
    }
}
